import { ROLE } from "../../../data/enums";

export const MATERIAL_STOCK_CARD_ROLES = [
    ROLE.MANAGER,
    ROLE.LOGISTIC_MANAGER,
    ROLE.LOGISTIC_STAFF,
    ROLE.STORAGE_KEEPER,
    ROLE.FIRST_STORAGE_KEEPER,
    ROLE.SECOND_STORAGE_KEEPER,
    ROLE.PURCHASING_STAFF,
    ROLE.PRODUCTION_STAFF,
    ROLE.ACCOUNTANT_MANAGER,
    ROLE.FACTORY_STAFF,
    ROLE.FACTORY_MANAGER_ONE,
    ROLE.FACTORY_MANAGER_TWO,
    ROLE.DEPUTY_FACTORY_MANAGER_ONE,
    ROLE.DEPUTY_FACTORY_MANAGER_TWO,
];

export const canCreateMaterialStockCard = (role: ROLE) => (
    MATERIAL_STOCK_CARD_ROLES.includes(role)
);
